import React, { useState, useEffect } from "react";
import ReusableDialog from "./controls/ReusableDialog";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import role from "../redux/actions/role";

export default function OnAppBlurDialog(props) {
  // eslint-disable-next-line
  const { open, text, succesBtnLabel, actionInfo, isTimerOn, ...other } = props;
  // const proctoringDetails = JSON.parse(localStorage.getItem("proctoring"));

  const proctoringDetails = useSelector((state) => state.role.candidateDashboardDetails.proctoring);
  // const classes = useStyles();
  // const quizState = useSelector((state) => state.quiz);
  const initialTimerValue =
    JSON.parse(localStorage.getItem("currentTimeOutDuration")) || proctoringDetails?.tabSwitchingTimerMax;
  const [dialogTimer, setDialogTimer] = useState(initialTimerValue);
  const [newTimerValue, setNewTimerValue] = useState(initialTimerValue);
  const [interval, setTimeInterval] = useState("");
  const MIN_TIMER = 5;
  const uid = localStorage.getItem("uid");
  const dispatch = useDispatch();

  const handleExitFullscreen = () => {
    // Check if the document is currently in fullscreen mode
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      // Exit fullscreen mode
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  const onClickContinue = () => {
    if (proctoringDetails?.tabSwitchingTimerGraded) {
      const updatedTimerValue = Math.max(newTimerValue - 5, MIN_TIMER);
      setNewTimerValue(updatedTimerValue);
      setDialogTimer(updatedTimerValue);
      localStorage.setItem("currentTimeOutDuration", JSON.stringify(updatedTimerValue));
    }
    clearInterval(interval);
    // console.log('continue')
    props.onCLickContinue();
  };

  useEffect(() => {
    if (isTimerOn && props.appFocusCount < proctoringDetails?.tabSwitchingLimit + 1) {
      setTimeInterval(
        setInterval(() => {
          setDialogTimer((prevState) => prevState - 1);
        }, 1000)
      );
    }
    if (!proctoringDetails) {
      dispatch(role.candidateDashboardDetails(uid));
    }
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (dialogTimer <= 0) {
      clearInterval(interval);
      props.onAutoSubmit();
      handleExitFullscreen();
    }
  }, [dialogTimer]);

  useEffect(() => {
    if (props.appFocusCount > proctoringDetails?.tabSwitchingLimit) {
      clearInterval(interval);
      props.onAutoSubmit();
      handleExitFullscreen();
    }
  }, [props.appFocusCount]);

  //   console.log('\n\n\n\n----',props.appFocusCount)

  return (
    <div>
      <ReusableDialog
        open={open}
        title="Warning!!"
        content={
          props.appFocusCount > proctoringDetails?.tabSwitchingLimit ? (
            <Typography>
              This test was out of focus for more than the permitted time. It will submit automatically now.
            </Typography>
          ) : (
            <>
              {isTimerOn ? (
                <>
                  {dialogTimer > 0 ? (
                    <>
                      You have moved out of the application. Please return in <b>{dialogTimer} seconds</b> to continue,
                      otherwise, the section will submit automatically.
                    </>
                  ) : (
                    <>This test was out of focus for more than the permitted time. It will submit automatically now.</>
                  )}
                </>
              ) : (
                ""
              )}
            </>
          )
        }
        actions={[{ onClick: onClickContinue, text: "Continue...", color: "btn1" }]}
      />
    </div>
  );
}
